import React, { useRef, useEffect, useCallback } from 'react'
import gsap from 'gsap'
import ProjectSlider from '../components/ProjectSlider'
import Menu from '../components/Menu'

function Project() {
  const wrapper = useRef(null)
  const line = useRef(null)
  const projectSection = useRef(null)

  let pageIndex = 0,
    canScroll = true //started index at 0


  const snapAnimation = (x, position) => {
    const { current } = wrapper,
      children = current.children

    const childAnimation = (target, direction) => {
      gsap.fromTo(target, {
        opacity: 0.5,
        x: direction
      }, {
        opacity: 1,
        x: 0,
        duration: 1.5,
        ease: 'power2.out',
        stagger: {
          from: "start",
          each: 0.3
        }
      })
    }

    if (position === "next" && pageIndex <= 1) {
      childAnimation(children[pageIndex].children, 100)
    }

    if (position === "prev" && pageIndex >= 0) {
      childAnimation(children[pageIndex].children, -100)
    }

    gsap.to(wrapper.current, {
      scrollLeft: pageIndex === 0 ? 0 : x * pageIndex,
      duration: 0.9,
      ease: "sine.out",
      onComplete: () => {
        canScroll = true
      }
    })

    return
  }

  const snapScrollStatusHandler = (status) => {
    return status
  }

  const snapScroll = useCallback((e) => {

    // check status dataset on swiper wrapper
    const slideWrapper = projectSection.current.children[1].children[0]
    const snapStatus = slideWrapper.dataset.onHover

    if (snapStatus === "true") return

    const y = e.deltaY,
      offset = wrapper.current.children[0].offsetWidth

    // snap previous
    if (y === -100 && canScroll) {

      if (pageIndex <= 0) return
      canScroll = false

      pageIndex--
      snapAnimation(offset, "prev")

      return

    }

    // snap next
    if (y === 100 && canScroll) {

      if (pageIndex >= 1) return
      canScroll = false

      pageIndex++
      snapAnimation(offset, "next")

      return
    }
  }, [snapScrollStatusHandler])


  const lineAnimation = () => {
    gsap.fromTo(line.current, { width: 0 }, { width: '6rem', duration: 1, repeat: -1, yoyo: true })
  }

  useEffect(() => {

    lineAnimation()
    const slideContainer = wrapper.current

    slideContainer.addEventListener('wheel', e => {
      snapScroll(e)
    })
    return () => {
      slideContainer.removeEventListener('wheel', e => snapScroll(e))
    }
  }, [wrapper, snapScroll])

  return (
    <>
      <Menu />
      <div className='project-page-container' data-can-scroll="true" ref={wrapper}>
        <div className="project-page-intro">
          <div className="intro-background">
            {/* <Sphere /> */}
          </div>
          <div className="intro">
            <h1>All My Works</h1>
            <div className="scroll-navigation">
              <span>Scroll</span>
              <div className="line">
                <hr ref={line} />
              </div>
            </div>
          </div>
        </div>
        <div className="content-section section-project-showcase" ref={projectSection}>
          <ProjectSlider />
        </div>
      </div>
    </>
  )
}

export default Project